module.exports = __webpack_public_path__ + "img/heading-character.4d41960d.png";